import { render } from "./PackageDetails.vue?vue&type=template&id=75ae000e&scoped=true"
import script from "./PackageDetails.vue?vue&type=script&lang=js"
export * from "./PackageDetails.vue?vue&type=script&lang=js"

import "./PackageDetails.vue?vue&type=style&index=0&id=75ae000e&scoped=true&lang=css"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ae000e"]])

export default __exports__